export const OncoprintGenes = ['BRAF', 'BRCA1', 'ERBB2', 'FGFR1', 'JAK1', 'JAK2', 'KIT', 'KRAS', 'KRAS', 'MAPK1', 'MAPK1', 'MDM2', 'MDM4', 'MTOR', 'MYC', 'NFKB1', 'NOTCH1', 'NRAS', 'PIK3CA', 'PTEN', 'SOX9', 'TP53'];

export default {
    OncoprintGenes,
};
